import type { ReactNode } from 'react'

type Props = {
  title: ReactNode
  body: ReactNode
}

export function NotificationText({ title, body }: Props) {
  const hasBody = body && body !== ' ' && body !== ''

  return (
    <div className="max-w-[880px]">
      <div className="leading-6">{title}</div>
      {hasBody && (
        <div className="text-sm font-medium leading-[21px]">{body}</div>
      )}
    </div>
  )
}
